import React from 'react';

interface LoadingMoreProps {
  message?: string;
}

export const LoadingMore: React.FC<LoadingMoreProps> = ({ 
  message = 'Loading more...' 
}) => {
  return (
    <div className="flex justify-center items-center py-6">
      <div className="flex items-center gap-2 text-sm text-gray-500">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-400"></div>
        <span>{message}</span>
      </div>
    </div>
  );
};

